import React, { Component } from "react";
import {
    Headerwrapper, NavCustom, UlCustom, LiCustomLogo, BrandLogo, LiCustomItem,
    LiCustomToggle, AnchorCustom, MenuIcon, LoginButton, LoginButtonColoured
} from "./headermenu.style"
import {
    Container,
} from '@bootstrap-styled/v4';
import ScrollSpy from 'react-scrollspy';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { StaticQuery, graphql } from 'gatsby';
import styles from './HeaderMenu.module.css';

class Headermenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stickyClass: 'top',
            isActive: false
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', () => {
            let stickyClass = 'topSticky';
            let scrollPos = window.scrollY;

            if (scrollPos < 100) {
                stickyClass = 'top';
            }

            if (this.state.stickyClass !== stickyClass) {
                this.setState({ stickyClass });
            }

        });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll');
    }

    menuClick = () => {
        this.setState({
            isActive: !this.state.isActive
        })
    }

    render() {

        return (
            <Headerwrapper isSticky={this.state.stickyClass === "topSticky" ? true : false}>
                <NavCustom isSticky={this.state.stickyClass === "topSticky" ? true : false}>
                    <Container className={styles.headerWrapper}>
                        <UlCustom>

                            <LiCustomLogo isSticky={this.state.stickyClass === "topSticky" ? true : false}>
                                <BrandLogo src={this.state.stickyClass === "topSticky" ? this.props.saasJson.Header.BrandLogoSticky : this.props.saasJson.Header.BrandLogo}
                                    isSticky={this.state.stickyClass === "topSticky" ? true : false}
                                    alt="Logo"
                                />
                            </LiCustomLogo>

                            <LiCustomItem className={this.state.isActive ? "active-main-li" : ""} isSticky={this.state.stickyClass === "topSticky" ? true : false}>
                                <ScrollSpy offset={-59} items={this.props.saasJson.Header.Items} currentClassName="is-current">
                                    {
                                        this.props.saasJson.Header.ScrollSpy.map((item, idx) => {
                                            return <li key={idx} className={this.state.isActive ? "active li-menu" : "li-menu"}>
                                                <AnchorLink offset={55} href={item.Href}>{item.Menu}</AnchorLink>
                                            </li>
                                        })
                                    }
                                    <li className="active li-menu">
                                        {this.state.stickyClass === "topSticky" ?
                                            <LoginButtonColoured href="https://admin.dockeeper.io/login">Login</LoginButtonColoured>
                                            :
                                            <LoginButton href="https://admin.dockeeper.io/login">Login</LoginButton>
                                        }
                                    </li>

                                </ScrollSpy>
                            </LiCustomItem>
                            <LiCustomToggle >
                                <AnchorCustom onClick={this.menuClick}>
                                    <MenuIcon isSticky={this.state.stickyClass === "topSticky" ? true : false} />
                                </AnchorCustom>
                            </LiCustomToggle>

                        </UlCustom>
                    </Container>
                </NavCustom>
            </Headerwrapper>
        );
    }
}

export default () => (
    <StaticQuery
        query={graphql`
            query{
                saasJson {
                    Header{
                        BrandLogo
                        BrandLogoSticky
                        Items
                        ScrollSpy{
                            Menu
                            Href
                        }
                    }
                }
            }
        `}
        render={(data) => (
            <Headermenu saasJson={data.saasJson} />
        )}
    />
)